import React from 'react';
import { Image, StyleSheet, TouchableOpacity, View, ActivityIndicator } from 'react-native';
import Icon from './Icon';

import { FontSize, CommonProperties, Color, CommonStyles } from '../styles';

import Button, { BUTTON_TYPES } from './Button';
import Images from '../constants/Images';
import BaseText from './BaseText';
import { scale } from '../utils/scale.utils';

import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

const GroupItem = ({ info, onEditPress, isUpdateAllowed = true }) => {
  return (
    <View style={itemStyles.itemContainer}>
      <Image style={itemStyles.image} source={info.icon ? info.icon : Images.defaultImage} />
      <View style={itemStyles.textGroup}>
        <View>
          <BaseText style={CommonStyles.body}>{info.label}</BaseText>
          <BaseText style={CommonStyles.small}>{info.small}</BaseText>
        </View>
        {isUpdateAllowed && (
          <TouchableOpacity onPress={onEditPress}>
            <Icon name="edit" size={FontSize.body} color={Color.text.high} />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

const GroupList = ({
  style,
  title,
  type,
  loading,
  onEditPress,
  onAddPress,
  items = [],
  isUpdateAllowed = true,
}) => {
  const { t } = useTranslation(i18nNS.me);
  const { tKey } = useComponentTKey('LoyaltyForm');
  return (
    <View style={[styles.container, style]}>
      <BaseText style={styles.title}>{title}</BaseText>
      <View>
        {items.map((item, index) => (
          <GroupItem
            key={index}
            info={item}
            onEditPress={() => {
              if (onEditPress) {
                onEditPress(index, type);
              }
            }}
            isUpdateAllowed={isUpdateAllowed}
          />
        ))}
        {loading && <ActivityIndicator style={styles.loadingIndicator} />}
        {isUpdateAllowed && (
          <Button
            iconName="plus"
            type={BUTTON_TYPES.TEXT}
            onPress={() => {
              onAddPress(type);
            }}
            label={t(tKey('Add')) + title}
          />
        )}
      </View>
    </View>
  );
};

const itemStyles = StyleSheet.create({
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Color.accent,
    ...CommonProperties.m3,
    ...CommonProperties.p3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
  image: {
    height: scale(36),
    width: scale(36),
    ...CommonProperties.mr3,
  },
  textGroup: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'rgb(252,252,252)',
    ...CommonProperties.py3,
  },
  title: {
    ...CommonProperties.body,
    ...CommonProperties.p3,
  },
  loadingIndicator: {
    ...CommonProperties.mr4,
    color: Color.primary,
  },
});

export default GroupList;
